module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-02.1.d36fde50.jpg";